export default "__VITE_ASSET__DaF8c2Co__"